module.exports = __webpack_public_path__ + "img/background_menu.fc0e3b60.jpg";